import React, { useState } from "react";
import ChildPinCode from "../../../../assets/images/pin-code.png";
import useLangTranslation from "../../../customHooks/languageProvider";
import { useDispatch, useSelector } from "react-redux";
import { setAddKidStatus } from "../../AxiosRtk/AddNewChild";
import { setupEmergencyPincode } from "../../AxiosRtk/PinCode";
import { setShowMessage } from "../../AxiosRtk/successMessage";
import useCrypto from "../../../customHooks/crypto";
import { getAccessToken } from "../../../../utils/helper";

const ChildDevicePinCode = () => {
  const { getLangTranslation } = useLangTranslation();
  const { user } = useSelector(({ auth }) => auth);
  const { newKidData, kidDeviceQRCode } = useSelector(
    ({ addNewChild }) => addNewChild
  );
  const dispatch = useDispatch();
  const { decryptRequest } = useCrypto();

  const [pincode, setPincode] = useState([
    { name: "digit1", value: "" },
    { name: "digit2", value: "" },
    { name: "digit3", value: "" },
    { name: "digit4", value: "" },
  ]);
  const [error, setError] = useState("");

  function handleInputChange(e) {
    const { name, value } = e.target;

    if (isNaN(value)) {
      setError("SHOULD_BE_NUMBER");
      return;
    }

    const temp = [...pincode];
    for (let i = 0; i < temp?.length; i++) {
      if (temp[i]["name"] === name) {
        temp[i]["value"] = value;
        if (error) {
          setError("");
        }
        break;
      }
    }
    setPincode(temp);
  }

  function hanldeNextClicked() {
    let numberCreated = "";
    pincode.forEach((item) => {
      numberCreated = numberCreated + item?.value;
    });

    if (numberCreated?.length !== 4) {
      setError("PINCODE_MUST_HAVE_FOUR_DIGIT");
      return;
    }

    if (user?.loginPin !== parseInt(numberCreated)) {
      setError("PINCODE_INCORRECT");
      return;
    } else {
      const kidId = newKidData[0]?.ID;
      const { accessToken } = getAccessToken(decryptRequest);
      setupEmergencyPincode({ kidId, deviceAttachPin: kidDeviceQRCode,deviceAttachQrCode: kidDeviceQRCode, accessToken })
        .then((res) => {
          dispatch(
            setShowMessage({
              showMessage: true,
              defaultMessage: res?.data?.message,
              message: res?.data?.message,
            })
          );
          dispatch(setAddKidStatus("CHILD_PROFILE_CREATED"));
        })
        .catch((err) => {
          console.log(
            "setup device attahed pincode catch error ==>>",
            err?.response?.data?.message
          );
        });
    }
  }

  return (
    <div className="card">
      <div className="card-body">
        <div className="content-400 mx-auto text-center">
          <h2 className="text-center mb-3 text-uppercase">
            {getLangTranslation("SETTINGS_PIN_CODE", "Pin Code")}
          </h2>
          <div className="my-9">
            <img src={ChildPinCode} alt="" />
          </div>
          <h5 className="mb-6">
            {getLangTranslation("DEVICE_FOUND_SUCCESS_TEXT", "Your device was successfully found")}
          </h5>
          <h5 className="text-small text-uppercase text-gray mb-2">
            {getLangTranslation("ENTER_YOUR_PIN_CODE_TITLE", "Enter your Pin Code")}
          </h5>
          <div className="verification-code-wrap">
            <div className="mb-6 grid gap-2">
              {pincode?.map((item) => {
                return (
                  <input
                    type="text"
                    className="form-control text-center g-col-3 fs-4"
                    name={item?.name}
                    maxLength="1"
                    value={item?.value}
                    onChange={handleInputChange}
                  />
                );
              })}
            </div>
          </div>
          {error && (
            <label className="field-error">{getLangTranslation(error)}</label>
          )}

          <button
            className="btn btn-primary w-100"
            type="button"
            onClick={hanldeNextClicked}
          >
            <span className="btn-upper-case">{getLangTranslation("ENTER_YOUR_PIN_CODE_NEXT", "NEXT")}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChildDevicePinCode;
